import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
export function formatAmount(amount, currency = "USDC") {
    const num = parseFloat(amount);
    if (isNaN(num))
        return `$0.00 ${currency}`;
    return `$${num.toFixed(2)} ${currency}`;
}
export function formatAddress(address, chars = 4) {
    if (address.length <= chars * 2 + 2)
        return address;
    return `${address.slice(0, chars + 2)}...${address.slice(-chars)}`;
}
export function formatHash(hash, chars = 6) {
    if (hash.length <= chars * 2)
        return hash;
    return `${hash.slice(0, chars)}...${hash.slice(-chars)}`;
}
export function formatDuration(seconds) {
    if (seconds < 60)
        return `${seconds}s`;
    if (seconds < 3600)
        return `${Math.floor(seconds / 60)}m ${seconds % 60}s`;
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    return `${h}h ${m}m`;
}
//# sourceMappingURL=utils.js.map